export enum SearchType {
  CONTRACT = 'contract',
  POLICY = 'policy',
  VIN = 'vin',
}

export const SEARCH_TYPE_LABELS: Record<SearchType, string> = {
  [SearchType.CONTRACT]: 'Contract #',
  [SearchType.POLICY]: 'Policy #',
  [SearchType.VIN]: 'VIN',
};

export const VALIDATION_MESSAGES = {
  queryRequired: 'Search query is required',
  queryMinLengthContract: 'Minimum 4 digits required',
  queryMinLengthVIN: 'Minimum 8 digits required',
  customerRequired: 'Please select a customer',
  clientRequired: 'Please select a client',
};

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export const CONTRACT_COLUMNS = [
  { id: 'contractId', label: 'Contract #' },
  { id: 'clientId', label: 'Client ID' },
  { id: 'customerName', label: 'Customer Name' },
  { id: 'address', label: 'Address' },
  { id: 'city', label: 'City' },
  { id: 'state', label: 'State' },
  { id: 'email', label: 'Email' },
];
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25];

export const SEARCH_FORM_CONSTANTS = {
  labels: {
    searchTitle: 'Search',
    activeOnly: 'Active only',
    client: 'Client',
    customerName: 'Customer Name',
    searchType: 'Search Type',
  },
  placeholders: {
    client: 'Type to search...',
  },
  radioLabels: {
    contract: 'Contract #',
    policy: 'Policy #',
    vin: 'VIN',
  },
  buttons: {
    reset: 'Reset',
    search: 'Search',
  },
  messages: {
    noData: 'No data found',
    recentlyOpened: 'Showing recently opened contracts',
    welcome: 'Welcome! Your recently opened contracts will show up here.',
    noResults: 'We could not find any contracts. Please refine your search and try again.',
  },
};

//Hardcoded username
export const USER = {
  username: 'AA0AAG', //'john.doe'
  user: 'AA0AAG', // harcode user for clients
};

export const CONTRACT_TABS = {
  INSURANCE: 0,
  NOTES: 1,
};

export const ContractTabsLabels = ['Insurance', 'Notes'];

export enum POPUP_TYPES {
  CONTRACT_LIST = 'contractList',
  CUSTOMER_DETAILS = 'customerDetails',
  EQUIPMENT_DETAILS = 'equipmentDetails',
  DEFICIENCY_DETAILS = 'deficiencyDetails',
  POLICY_BILLING_DETAILS = 'policyBillingDetails',
  AGENT_DETAILS = 'agentDetails',
}

export const CUSTOMER_CONTRACTS = {
  TITLE: 'Customer Contracts',
  SUBTITLE: 'List of all contracts for the selected contract.',
  HEADERS: [
    'Contract #',
    'Branch',
    'Private Label',
    'Cycle',
    'Equip Value', // Renaming as per business requirement
    'Block',
    'B Class',
    'L. Class',
    'C. Class',
    'Coll. Description',
    'Serial #',
  ],
};

export const POLICY_BILLING = {
  TITLE: 'Policy Billing Details',
  SUBTITLE: 'The amounts shown do not reflect any policy re-rating adjustments.',
  HEADERS: [
    'Policy Effective',
    'Policy Expiration',
    'Original Invoice Amount',
    'Original Ins. Premium',
    'Invoice Due Date',
  ],
};

export const ATTACHMENT_FILE = {
  pdf: 'Attachment.pdf',
};
